import React from 'react';
import { InfoOutlined } from '@mui/icons-material';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  tooltipTriggerText: {
    fontSize: 15,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    letterSpacing: 0,
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textDecorationColor: '#b0b0b0',
    textUnderlineOffset: '2px',
    color: '#656565',

    '& svg': {
      marginTop: -2,
      marginLeft: 4,
      marginRight: 8,
    },
  },
  marginTop: {
    marginTop: 4,
  },
}));

type Props = {
  content: React.ReactNode;
  icon?: boolean;
  noMarginTop?: boolean;
};

const TooltipTriggerText: React.FC<Props> = ({
  content,
  icon,
  noMarginTop = false,
}) => {
  const { classes } = useStyles();

  const classNames = [classes.tooltipTriggerText];
  if (!noMarginTop) {
    classNames.push(classes.marginTop);
  }

  return (
    <span className={classNames.join(' ')}>
      {content} {icon ? <InfoOutlined style={{ fontSize: 18 }} /> : null}
    </span>
  );
};

export default TooltipTriggerText;
